<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">提现过审配置</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-table :data="tableData" style="margin-top:20px">
        <el-table-column type='index' label="序号"> </el-table-column>
        <el-table-column prop="name" label="自动过审的前置条件">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.conditionList" :key="index">{{item.conditionName+':'+item.conditionDesc}}</div>
          </template>
        </el-table-column>
        <el-table-column label="开关" width='50px'>
          <template slot-scope="scope">
            <el-switch
              @change="switchUpda(scope.row,$event)"
              v-model="scope.row.configStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value=1
              :inactive-value=0
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button v-if="scope.row.adjustParamSwitch == 1" @click="handleClickone(scope.row)" type="primary">
              调整过审参数
            </el-button>
            <el-button v-if="scope.row.adjustNetworkSwitch == 1" @click="handleClicktwo(scope.row)" type="primary">
              选择网络
            </el-button>
            <el-button v-if="scope.row.adjustSpecialCoinSwitch == 1" @click="handleClickthree(scope.row)" type="primary">
              选择特定币种
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose">
      <span>确认打开/关闭吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSwitch">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="调整过审参数"
      :visible.sync="dialone"
      width="=700px"
      @close="handleClose">
      <div class="dialbox">
        <div class="inputsetting">
          <span>当日个人单笔自动过审金额：</span>
          <el-input v-model="clickoneObj.singleAmount" style="width:50%;margin-right:20px"></el-input>
          <el-switch
            v-model="clickoneObj.singleAmountStatus"
            active-text="无限制">
          </el-switch>
        </div>
        <div class="inputsetting">
          <span>当日个人累计自动过审金额：</span>
          <el-input v-model="clickoneObj.sumAmount" style="width:50%;margin-right:20px"></el-input>
          <el-switch
            v-model="clickoneObj.sumAmountStatus"
            active-text="无限制">
          </el-switch>
        </div>
        <div class="inputsetting">
          <span>当日个人累计自动过审次数：</span>
          <el-input v-model="clickoneObj.sumCount" style="width:50%;margin-right:20px"></el-input>
          <el-switch
            v-model="clickoneObj.sumCountStatus"
            active-text="无限制">
          </el-switch>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialone = false">取 消</el-button>
        <el-button type="primary" @click="adjustment">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择网络"
      :visible.sync="network"
      width="=800px"
      @close="handleClose">
      <div class="selectNetwork">
       <el-checkbox :indeterminate="isIndeterNetwork" v-model="networkAll" @change="handleCheckAllNetwork">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="seleNetworkCities" @change="handleCheckedNetwork">
          <el-checkbox v-for="(item,index) in seleNetwork" :label="item" :key="item.chainType+index">{{item.chainType}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="network = false">取 消</el-button>
        <el-button type="primary" @click="adjustNetwork">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择特定币种"
      :visible.sync="selecoin"
      width="1000px"
      @close="handleClose">
      <div class="selecoinbox">
        <span>主区</span>
       <el-checkbox :indeterminate="isIndeterMain" v-model="mainCheckAll" @change="handleMainAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="mainAreaCities" @change="handleMainArea">
          <el-checkbox v-for="(item,index) in mainArea" :label="item" :key="item.coinType+index">{{item.coinType}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="selecoinbox">
        <span>创新区</span>
       <el-checkbox :indeterminate="isIndeterInnovate" v-model="innovateCheckAll" @change="handleInnovateAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="innovateCities" @change="handleCheckedCitiesInnovate">
          <el-checkbox v-for="(item,index) in innovate" :label="item" :key="item.coinType+index">{{item.coinType}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selecoin = false">取 消</el-button>
        <el-button type="primary" @click="specialCoin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "./store";
import { mapState, mapMutations, mapActions } from "vuex";
import api from './api.js'
export default {
  data() {
    return {
      tableData: [],
      dialogVisible:false,
      dialone:false,
      network:false,
      value1:'',
      networkAll:false,
      mainCheckAll:false,
      innovateCheckAll:false,

      cities: [],
      isIndeterminate: true,
      isIndeterNetwork:true,
      isIndeterMain:true,
      isIndeterInnovate:true,
      selecoin:false,
      seleObj:{},
      clickoneObj:{},
      innovateObj:{},
      seleNetworkObj:{},
      mainArea:[],
      mainAreaCities:[],
      innovate:[],
      innovateCities:[],
      seleNetwork:[],
      seleNetworkCities:[]
    };
  },
  computed: {
    ...mapState("automaticAudit", ["allCoins"]),
  },
  created(){
    this.getList();
  },
  methods: {

    handleClose(){
     
      this.isIndeterMain = true;
      this.mainAreaCities = [];
      this.isIndeterNetwork = true;
      this.isIndeterInnovate = true;
      this.innovateCities = [];
      this.getList();
    },
    getList(){
      api.ruleList().then(res=>{
        let reg = /\${(.*?)\}/gi;
        res.data.map(item=>{
          item.conditionList.filter(child=>{
            let tmp = child.conditionDesc.match(reg)
            if(tmp){
              let network = item.network;
             return child.conditionDesc = child.conditionDesc.replace(tmp,network);
            }
          })
        })
        this.tableData = res.data;
      })
    },
    switchUpda(res,index){
      this.seleObj = res;
      this.dialogVisible = true;
     
    },
    onSwitch(){
      let data = {
        configStatus:this.seleObj.configStatus,
        id:this.seleObj.id
      }
      api.approvalswitch(data).then(res=>{
        // console.log(res)
         this.getList();
        this.$message.success('修改成功!')
      })
      this.dialogVisible = false;
    },
    handleClickone(data){ //规则详情
      this.dialone = true;
      api.paramsDetail({id:data.id}).then(res=>{
        this.clickoneObj = res.data;
      })
    },
    adjustment(){//规则详情修改
      api.adjustParams(this.clickoneObj).then(res=>{
        this.$message.success('修改成功!');
        this.getList();
        this.dialone = false;
      })
    },
    handleClicktwo(data){//请求链路网络列表
      this.network = true;
      this.seleNetworkObj = data;
      let ary = []
      api.network({id:data.id}).then(res=>{
        res.data.map(item=>{
          if(item.choice){
            ary.push(item)
          }
        })
        console.log(ary)
        this.seleNetworkCities = ary;
        this.seleNetwork = res.data;
      })
    },
    adjustNetwork(){//调整参数
      let coinAry = []
      for(let item of this.seleNetworkCities){
        coinAry.push(item.chainType)
      }
      let data = {
        choiceNetworks:coinAry,
        id:this.seleNetworkObj.id,
      }
      api.getadjustNetwork(data).then(res=>{
        this.$message.success('调整成功！')
        this.getList();
        this.network = false;
      })
    },
    
    handleClickthree(data){//获取特殊币种列表
      this.selecoin = true;
      this.innovateObj = data;
      api.specialCoinList({id:data.id}).then(res=>{
        res.data.mainAreaCoins.map(item=>{
          if(item.choice){
            this.mainAreaCities.push(item)
          }
        })
        res.data.innovateAreaCoins.map(item=>{
          if(item.choice){
              this.innovateCities.push(item);
          }
        })
        this.innovate = res.data.innovateAreaCoins;
        this.mainArea = res.data.mainAreaCoins;
      })
    },
    specialCoin(){//选择特殊币种
      let coinAry = [];
      for(let i of this.innovateCities){
        coinAry.push(i.coinType)
      }
      for(let i of this.mainAreaCities){
        coinAry.push(i.coinType)
      }
      api.adjustSpecialCoins({id:this.innovateObj.id,specialCoinList:coinAry}).then(res=>{
        this.$message.success('选择成功!');
        this.getList();
        this.selecoin = false;
      })
    },
    
    handleCheckAllNetwork(val){//选择网络全选
      this.seleNetworkCities = val ? this.seleNetwork : [];
      this.isIndeterNetwork = false;
    },
    handleCheckedNetwork(value){
      let checkedCount = value.length;
      this.networkAll = checkedCount === this.seleNetwork.length;
      this.isIndeterNetwork = checkedCount > 0 && checkedCount < this.seleNetwork.length;
    },
    handleMainAllChange(val){//主区全选
    console.log(val)
      this.mainAreaCities = val ? this.mainArea : [];
      this.isIndeterMain = false;
    },
    handleMainArea(value){
      let checkedCount = value.length;
      this.mainCheckAll = checkedCount === this.mainArea.length;
      this.isIndeterMain = checkedCount > 0 && checkedCount < this.mainArea.length;
    },
    
    handleInnovateAllChange(val){//创新全选
      this.innovateCities = val ? this.innovate : [];
      this.isIndeterInnovate = false;
    },
    handleCheckedCitiesInnovate(value){
      let checkedCount = value.length;
      this.innovateCheckAll = checkedCount === this.innovate.length;
      this.isIndeterInnovate = checkedCount > 0 && checkedCount < this.innovate.length;
    },
  },
};
</script>
<style lang='less' scoped>
.dialbox{
  .inputsetting{
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
.selectNetwork{
  .el-checkbox{
    width: 110px;
  }
  .el-checkbox+.el-checkbox{
    margin-left: 0px;
  }
}
.selecoinbox{
  .el-checkbox{
    width: 135px;
  }
  .el-checkbox+.el-checkbox{
    margin-left: 0px;
  }
  &:last-child{
    margin-top: 40px;
  }
}
/deep/.el-dialog__body{
  padding-top: 0px;
}
.selecoinbox{

}
</style>
